import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeHeroQuoteSection'
 * @name TypeHeroQuoteSectionFields
 * @type {TypeHeroQuoteSectionFields}
 * @memberof TypeHeroQuoteSection
 */
export interface TypeHeroQuoteSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'quotee' (Quotee)
     * @name Quotee
     * @localized false
     */
    quotee?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'quote' (Quote)
     * @name Quote
     * @localized true
     */
    quote: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'image' (Image)
     * @name Image
     * @localized false
     */
    image?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'backgroundColor' (Background Color)
     * @name Background Color
     * @localized false
     */
    backgroundColor: EntryFieldTypes.Symbol<"blue" | "dark-blue" | "gold" | "green" | "grey" | "light-blue" | "magenta" | "red" | "white" | "yellow">;
    /**
     * Field type definition for field 'cardAlignment' (Card Alignment)
     * @name Card Alignment
     * @localized false
     */
    cardAlignment: EntryFieldTypes.Symbol<"Left" | "Right">;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
    /**
     * Field type definition for field 'shadowColor' (Shadow Color)
     * @name Shadow Color
     * @localized false
     */
    shadowColor?: EntryFieldTypes.Symbol<"blue" | "dark-blue" | "gold" | "green" | "light-blue" | "magenta" | "red" | "yellow">;
}

/**
 * Entry skeleton type definition for content type 'heroQuoteSection' (Hero Quote Section)
 * @name TypeHeroQuoteSectionSkeleton
 * @type {TypeHeroQuoteSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T12:52:56.704Z
 * @version 35
 */
export type TypeHeroQuoteSectionSkeleton = EntrySkeletonType<TypeHeroQuoteSectionFields, "heroQuoteSection">;
/**
 * Entry type definition for content type 'heroQuoteSection' (Hero Quote Section)
 * @name TypeHeroQuoteSection
 * @type {TypeHeroQuoteSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T12:52:56.704Z
 * @version 35
 */
export type TypeHeroQuoteSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeHeroQuoteSectionSkeleton, Modifiers, Locales>;

export function isTypeHeroQuoteSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeHeroQuoteSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'heroQuoteSection'
}
